import { AlertTriangle, UserRound } from "lucide-react";

// Operators only: explains why their board is empty (no line yet) or which lines they're looking at.
export default function OperatorScopeBanner({ scope }) {
  if (!scope.scoped) return null;
  if (!scope.assigned) {
    return (
      <div className="flex items-start gap-3 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm" data-testid="operator-unassigned-banner">
        <AlertTriangle className="h-5 w-5 text-amber-600 shrink-0 mt-0.5" />
        <div>
          <p className="font-semibold text-amber-900">You're not assigned to any line yet — ask your admin.</p>
          <p className="text-xs text-amber-700 mt-0.5">Jobs and machines appear here as soon as an administrator assigns you to a production line (Lines &amp; Machines → Assign, or Users → Edit).</p>
        </div>
      </div>
    );
  }
  const codes = scope.machines.map((m) => m.line_code).join(" · ");
  return (
    <div className="flex items-center gap-2 rounded-lg border border-blue-100 bg-blue-50/70 px-3 py-2 text-xs text-blue-800" data-testid="operator-scope-banner">
      <UserRound className="h-3.5 w-3.5 shrink-0" />
      <span>Showing only your line{scope.machines.length !== 1 ? "s" : ""}: <b className="font-mono-data">{codes}</b> · {scope.orders.length} job{scope.orders.length !== 1 ? "s" : ""}</span>
    </div>
  );
}
